




































import {Component, Prop, Vue} from "vue-property-decorator";
import VueError from "@/components/VueError.vue";
import TimestampAgo from "@/components/TimestampAgo.vue";
import tippy from "tippy.js";
import {NTag, NTagLocation} from "@/types/ntag";

@Component({
  components:{
    VueError,
    TimestampAgo,
  }
})
export default class NtagLocationRow extends Vue {
  error:string = '';
  @Prop({ default: {},  type: Object}) location!: NTagLocation;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
  @Prop({ default: 'deviceId',  type: String}) orderBy!: 'deviceId'|'lastUplinkTs'|'location.name';
  @Prop({ default: 'asc',  type: String}) ascDesc!: 'asc'|'desc';

  mounted() {
    // nothing yet
    tippy('[data-tippy-content]');
  }

  toggleOrder(newOrderBy:'deviceId'|'lastUplinkTs'|'location.name') {

    // we are clicking on what we are ordering by already
    if(this.orderBy === newOrderBy)
      return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: this.ascDesc === 'asc' ? 'desc' : 'asc'});

    // we are clicking on another column -> we default to asc
    switch(newOrderBy) {
      case 'deviceId':
      case 'location.name':
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'asc'});
      case 'lastUplinkTs':
        return this.$emit('new-order-by', {orderBy: newOrderBy, ascDesc: 'desc'});
    }
  }

  goToLocationPage(baseStationId:string) {
    this.$router.push(`/applications/ntag/locations/${baseStationId}`);
  }

  get renderEnterprise(): string {
    return this.location.enterpriseId ? `${this.location.enterpriseId.replace(/^nnn\./, '')}` : 'not defined';
  }

  get renderBaseStations(): string {
    return this.location.bssIdsList.join(', ');
  }
}
